import { apiClient } from "../common/axiosInstance"
import { IInactivateUserResponse } from "./types";
import { handleAxiosError } from "../common/handleAxiosError";

export const inactivateUser = async (username: string) => {

  try {
    const response: IInactivateUserResponse = await apiClient.put(`/users/inactivate?username=${username}`);
    return response;
  } catch (error) {
    handleAxiosError(error, "Error al inactivar el usuario");
  }
}